import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CtrlIconComponent } from '@co-3/ctrl-ui/icons';

@Component({
    selector: 'app-portal-action-buttons',
    imports: [NgClass, CtrlIconComponent],
    templateUrl: './portal-action-buttons.component.html',
    styleUrl: './portal-action-buttons.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PortalActionButtonsComponent {
    public confirmText = input<string>('Weiter');
    public confirmIcon = input<string | null>(null);
    public isConfirmDisabled = input<boolean>(false);
    public styleConfirmNegative = input<boolean>(false);

    public rejectText = input<string>('Zurück');
    public rejectIcon = input<string | null>(null);
    public styleRejectNegative = input<boolean>(true);

    public clickReject = output<void>();
    public clickConfirm = output<void>();

    public isUsedToSubmitForm = input.required<boolean>();
}
